export default "__VITE_ASSET__D76E42u7__"